"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScrollBox = exports.StyledMobileImageBox = exports.Image = exports.StyledMobileFolderList = exports.StyledSlideImageMainBox = exports.StyleSlideItemBox = exports.StyledSliderBox = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _StyledLayout = require("../../../../../StyledLayout");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var StyledSliderBox = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__StyledSliderBox",
  componentId: "sc-1w87efq-0"
})(["position:relative;background:", ";padding:68px 0 0;height:calc(100% - 76px);.slick-slide{margin-right:110px;&:last-child{margin-right:0;}}.slick-track{left:248px;}.slick-arrow{display:none !important;}", ""], function (props) {
  return props.theme.portfolioBackground1;
}, function (props) {
  return props.isDesktopSmall && (0, _styledComponents.css)([".slick-track{left:288px;}"]);
});
exports.StyledSliderBox = StyledSliderBox;

var StyleSlideItemBox = _styledComponents["default"].div.withConfig({
  displayName: "Elements__StyleSlideItemBox",
  componentId: "sc-1w87efq-1"
})(["&:hover{.newton-folder-name{color:", ";}}img{object-fit:contain;transition:all 0.6s;}img{&:hover{transform:scale(1.1);}}"], function (props) {
  return props.theme[props.colour];
});

exports.StyleSlideItemBox = StyleSlideItemBox;
var StyledSlideImageMainBox = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__StyledSlideImageMainBox",
  componentId: "sc-1w87efq-2"
})(["height:", ";width:unset;overflow:hidden;margin-right:80px;"], function (props) {
  return "".concat(props.height, "px");
});
exports.StyledSlideImageMainBox = StyledSlideImageMainBox;
var StyledMobileFolderList = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__StyledMobileFolderList",
  componentId: "sc-1w87efq-3"
})(["height:100%;background:", ";position:relative;display:flex;flex-direction:column;padding:76px 16px 72px;"], function (props) {
  return props.theme.portfolioBackground1;
});
exports.StyledMobileFolderList = StyledMobileFolderList;

var Image = _styledComponents["default"].img.withConfig({
  displayName: "Elements__Image",
  componentId: "sc-1w87efq-4"
})(["width:100%;height:100%;object-fit:cover;"]);

exports.Image = Image;
var StyledMobileImageBox = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__StyledMobileImageBox",
  componentId: "sc-1w87efq-5"
})(["max-height:512px;min-height:184px;overflow:hidden;"]);
exports.StyledMobileImageBox = StyledMobileImageBox;
var ScrollBox = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__ScrollBox",
  componentId: "sc-1w87efq-6"
})(["position:relative;display:flex;overflow-y:scroll;box-sizing:border-box;padding-left:248px;padding-right:80px;", " &::-webkit-scrollbar{display:none;}"], function (props) {
  return props.isDesktopSmall && (0, _styledComponents.css)(["padding-left:288px;"]);
});
exports.ScrollBox = ScrollBox;